var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.502,
    height: 31.09,
    viewBox: "0 0 38.502 31.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M0,20.276,12.413,7.863l7.408,7.408L33.162,0,32.2,6.814l-2.479,17.64Z",
    transform: "translate(1.129 5.745) rotate(-8)",
    fill: "#FFD204",
    stroke: "#343333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphYellow);
export default __webpack_public_path__ + "static/media/graph-yellow.5713c943e97a8e0ff98fc8c2aa14beb0.svg";
export { ForwardRef as ReactComponent };